module.exports = __webpack_public_path__ + "static/media/24-hour-service.5c72c7fd.ico";